export const NAVIGATOR_TOGGLE_DRAWER = 'NAVIGATOR_TOGGLE_DRAWER';
export const NAVIGATOR_WEB_INITIALIZED = 'NAVIGATOR_WEB_INITIALIZED';
export const NAVIGATOR_SET_CURRENT_ROUTE = 'NAVIGATOR_SET_CURRENT_ROUTE';
